import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(main)/(all)/scratch-card/template.tsx");
